import React from "react";
import { useParams } from "react-router-dom";
import { useProductInquiryById } from "../../../../../api/inquiries/product-inquiry/use-product-inquiry-detail";
import {
  useReviewById,
  useToggleReview,
} from "../../../../../api/inquiries/review/use-review-detail";
import { useInquiryStats } from "../../../../../api/inquiries/stats/use-inquiry-stats";
import TitlePage from "../../../../../components/section/TitlePage/Titlepage";
import Tabs, { Tablist } from "../../../../../components/ui/Tabs/Tabs";

import DetailItem from "./DetailItem";

const tabs = (data) => {
  return [
    {
      title: "상품 문의",
      id: 1,
      totalData:
        data?.numOfProductInquiry !== 0 ? data?.numOfProductInquiry : "0",
    },
    {
      title: "1:1 문의",
      id: 2,
      totalData: data?.numOfInquiry !== 0 ? data?.numOfInquiry : "0",
    },
    {
      title: "상품 리뷰",
      id: 3,
      totalData:
        data?.numOfProductReview !== 0 ? data?.numOfProductReview : "0",
    },
    {
      title: "공지사항",
      id: 4,
      totalData: data?.numOfNotice !== 0 ? data?.numOfNotice : "0",
    },
    {
      title: "FAQ",
      id: 5,
      totalData: data?.numOfFaq !== 0 ? data?.numOfFaq : "0",
    },
    {
      title: "이벤트",
      id: 6,
      totalData: data?.numOfEvent !== 0 ? data?.numOfEvent : "0",
    },
    {
      title: "동영상",
      id: 7,
      totalData: data?.numOfVideo !== 0 ? data?.numOfVideo : "0",
    },
  ];
};

const ProductReviewDetailPage = () => {
  const { id } = useParams();
  const { data } = useReviewById(id);
  const { data: inquiryData } = useInquiryStats();
  const inquiryStats = inquiryData?.data;
  const productReviewData = data?.data;
  const [currentTab, setCurrentTab] = React.useState(3);
  const { mutate: toggleReview } = useToggleReview({ id: id });

  const onChangeTab = (id) => {
    setCurrentTab(id);
  };

  const handleHide = async () => {
    await toggleReview({
      id: id,
    });
  };

  return (
    <div>
      <TitlePage title="상품 리뷰 > 상품 리뷰 상세" />
      <Tabs
        isDisabled={true}
        tabWidth="w-24"
        titleTabPosition="justify-between"
        onChangeTab={onChangeTab}
        currentTab={currentTab}
        tabs={tabs(inquiryStats)}
      >
        <Tablist currentTab={currentTab} index={1}></Tablist>
        <Tablist currentTab={currentTab} index={2}></Tablist>
        <Tablist currentTab={currentTab} index={3}>
          <DetailItem data={productReviewData} handleHide={handleHide} />
        </Tablist>
        <Tablist currentTab={currentTab} index={4}></Tablist>
        <Tablist currentTab={currentTab} index={5}></Tablist>
        <Tablist currentTab={currentTab} index={6}></Tablist>
      </Tabs>
    </div>
  );
};

export default ProductReviewDetailPage;
